import { useStoreConfig } from '@config/hooks/useStoreConfig'
type CountryInfo = {
    url: string
    country: string
    code: string
    storeCode: string
    disabled?: boolean
}
export const useLocationCountryDetail = (): {
    currentLocationDetail: CountryInfo
    countryDetail: CountryInfo[]
} => {
    const {
        base: { otherWebsiteUrls }
    } = useStoreConfig()
    const baseStoreCode = process.env.NEXT_PUBLIC_STORE_CODE
    const countryDetail = [
        {
            url: otherWebsiteUrls!.ooka_ae,
            country: 'UAE',
            code: 'AE',
            storeCode: 'ooka_uae_store',
            disabled: false
        },
        {
            url: otherWebsiteUrls!.ooka_us,
            country: 'USA',
            code: 'US',
            storeCode: 'ooka_usa_store',
            disabled: false
        }
    ]

    const currentLocationDetail = countryDetail.find(
        (website) => website.storeCode === baseStoreCode
    ) as CountryInfo

    return {
        currentLocationDetail,
        countryDetail
    }
}
